import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Suspense, lazy, useEffect, useState } from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import ScrollToTop from "./components/ScrollToTop";
import Navigation from "./components/Navigation";

import AOS from "aos";
import "aos/dist/aos.css";

// 페이지 컴포넌트 Lazy 로딩
const Main = lazy(() => import("./page/Main"));
const Mobile = lazy(() => import("./page/Mobile"));
const Company = lazy(() => import("./page/Company"));
const Contact = lazy(() => import("./page/Contact"));
//const Landing = lazy(() => import("./page/Landing"));

function App() {
	const [isMobile, setIsMobile] = useState(false);
	// 화면 크기 변경 감지
	
	const handleResize = () => {
		// 화면 너비가 768px 이하면 모바일로 간주 (이 값은 필요에 따라 조정)
		setIsMobile(window.innerWidth <= 768);
	};

	useEffect(() => {
		// 초기 체크
		handleResize();

		// 리사이즈 이벤트 리스너 등록
		window.addEventListener("resize", handleResize);

		// 컴포넌트 언마운트 시 이벤트 리스너 제거
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	useEffect(() => {
		document.oncontextmenu = function () {
			return false;
		}
	}, [])

	useEffect(() => {
		AOS.init();
	}, [])

	return (
		<Router>
			<ScrollToTop />
			<div className="App">
				<Suspense fallback={<div className="loading"><span className="loader"></span></div>}>
					{isMobile ? (
						<>
							<Navigation isMobile={true} />
							<Routes>
								<Route path="/" element={<Mobile />} />
								<Route path="/contact" element={<Contact />} />
							</Routes>
						</>
					):(
					<>
						<Navigation isMobile={false} />
						<Routes>
							<Route path="/" element={<Main />} />
							<Route path="/company" element={<Company />} />
							<Route path="/contact" element={<Contact />} />
						</Routes>
					</>
					)}
				</Suspense>
			</div>
		</Router>
	);
}

export default App;
